<script lang="ts">
    import { Link } from '@inertiajs/svelte';
    import { privacy, feedback } from '@/routes';
</script>

<footer class="border-t border-gray-800 bg-gray-900 mt-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-gray-500">
        <span>Built and &copy; {new Date().getFullYear()} by <a href="https://ceejayoz.com" class="rainbow-text" target="_blank" rel="noopener">Chris Sternal-Johnson</a></span>
        <div class="flex items-center gap-4">
            <Link href={privacy()} class="hover:text-gray-300">Privacy</Link>
            <Link href={feedback()} class="hover:text-gray-300">Feedback</Link>
        </div>
    </div>
</footer>

<style>
    .rainbow-text {
        background: linear-gradient(
            90deg,
            #ff0000, #ff8800, #ffff00, #00cc00, #0066ff, #8800ff, #ff0000
        );
        background-size: 200% 100%;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        animation: rainbow-scroll 3s linear infinite;
    }

    @keyframes rainbow-scroll {
        0% { background-position: 0% 50%; }
        100% { background-position: 200% 50%; }
    }
</style>
